import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FiveStars = _resolveComponent("FiveStars")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FiveStars, {
        "filled-star-image-src": _ctx.filledStarImageSrc,
        "filled-star-half-image-src": _ctx.filledStarHalfImageSrc,
        value: _ctx.evaluationRound(_ctx.value),
        size: _ctx.size,
        class: "mr-2"
      }, null, 8, ["filled-star-image-src", "filled-star-half-image-src", "value", "size"]),
      _createTextVNode(),
      _createElementVNode("span", {
        class: _normalizeClass(["mr-1", `text-size-${_ctx.textSize}`])
      }, _toDisplayString(_ctx.evaluationRound(_ctx.value)) + "点", 3)
    ])
  ]))
}